// Variations of the generic "Loading.." component
import React, { createContext, useState } from 'react';

export const GlobalLoaderContext = createContext();

export const GlobalLoaderProvider = ({children}) => {

    const [loading, setLoading] = useState(false);

    return <GlobalLoaderContext.Provider value={{loading, setLoading}}>{children}</GlobalLoaderContext.Provider>
}